import { render, staticRenderFns } from "./PromptBox.vue?vue&type=template&id=5dba6862&scoped=true"
import script from "./PromptBox.vue?vue&type=script&lang=js"
export * from "./PromptBox.vue?vue&type=script&lang=js"
import style0 from "./PromptBox.vue?vue&type=style&index=0&id=5dba6862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dba6862",
  null
  
)

export default component.exports